import { Link } from "react-router-dom";

const FloatingHomeRequestButton = () => {
  return (
    <Link
      to="/hire"
      className="fixed z-20 bottom-6 left-6 bg-secondary text-primary rounded-full flex items-center gap-2.5 pl-3 pr-4 py-3 shadow-course-lockup custom-btn"
    >
      <span className="w-7 h-7 rounded-full bg-primary text-white flex items-center justify-center">
        +
      </span>
      <strong className="text-xs">Start hiring request</strong>
    </Link>
  );
};

export default FloatingHomeRequestButton;
